var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFunds = function SvgFunds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 48.584 47.723"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12160",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83883",
    d: "M27.351 6.523L14.318 17.714 1.142 10.632 16.176.75l31.03 15.873-15.08 10.117-11.444-6.082 13.389-10.657",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83884",
    d: "M6.566 13.907L1.294 17.43l12.678 6.75",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83885",
    d: "M6.507 20.285L.75 24.049l13.189 6.924",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83886",
    d: "M6.894 27.43l-5.777 3.993L32.06 46.972l15.035-9.771-5.712-2.87",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83887",
    d: "M42.132 20.29l5.7 2.971-15.7 10.553-11.444-6.035",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83888",
    d: "M42.777 27.121l5.056 2.454-15.7 10.553-11.444-6.035",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83889",
    d: "M20.688 20.675l-.3 20.378"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83890",
    d: "M14.275 17.807l-.3 19.959"
  }))));
};

export default SvgFunds;